import { AfterViewInit, Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ONBOARD_CONSTANTS } from 'src/app/app.constants';
import { AppService } from 'src/app/app.service';
import { AccessibilityService } from 'src/app/services/accessibility.service';
import { ActivateService } from 'src/app/services/activate.service';
import { DatalayerService } from 'src/app/services/datalayer.service';
import { HttpService } from 'src/app/services/http.service';
import { ErrorService } from '../error/error.service';
import { LandingComponent } from '../landing/landing.component';
import { LandingService } from '../landing/landing.service';
import { TravelersService } from '../travelers/travelers.service';


@Component({
  selector: 'app-crew-voucher',
  templateUrl: './crew-voucher.component.html',
  styleUrls: ['./crew-voucher.component.css']
})
export class CrewVoucherComponent implements OnInit {

  @ViewChild(LandingComponent) public landingComponent: LandingComponent;

  deviceStatusFun;
  public showToggleButton = LandingComponent.showToggleButton;
  activateCallSuccess = false;
  activateCallCompleted = false;
  showEmailErrorMsg = false;
  eRgex: RegExp;
  private vouchercode: String;
  public voucherError: String;
  crewForm: FormGroup;
  showVoucherError = false;
  voucherForm: FormGroup;
  regEx: RegExp;
  voucherTopSet = false;
  showVoucherErrorMsg = false;
  showFnameErrorMsg = false;
  showLnameErrorMsg = false;
  voucherFocused = false;
  fNameFocused = false;
  lNameFocused = false;
  emailFocused = false;
  pnrTopSet = false;
  public displayVoucherInfoIcon = true;
  public displayVoucherInfo = false;
  public displayEmailInfo = false;
  fnameTopSet = false;
  lnameTopSet = false;

  emailTopSet = false;
  public isSiteLogin: boolean;
  showErrorMsg = true;
  private deviceTokenCount: any;
  private deviceTokenCountVal: any;

  constructor(
    private deviceService: DeviceDetectorService,
    private activateService: ActivateService,
    private datalayerService: DatalayerService,
    private travelersService: TravelersService,
    private landingService: LandingService,
    private fb: FormBuilder,
    private errorService: ErrorService,
    private appService: AppService,
    private translate: TranslateService,
    private accessibilityService: AccessibilityService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private httpService: HttpService



  ) { }

  ngOnInit(): void {
    this.appService.getDeviceToken();
    this.landingService.setDeviceName(this.deviceService);
    this.landingService.getGetDeviceResponse();

    this.landingService.getDeviceName();
    this.landingService.checkDeviceStatus();

    this.eRgex = /^[_a-zA-Z0-9+.-]+@sas.[se,com,no,dk]+$/;
    this.crewForm = this.fb.group({
      'firstName': ['', [Validators.required,
      Validators.pattern('^[\\sa-zA-Z\\u0080-\\u00ff\.\'\-]*$'),
      Validators.minLength(2),
      Validators.maxLength(32)]],
      'lastName': ['', [Validators.required,
      Validators.pattern('^[\\sa-zA-Z\\u0080-\\u00ff\.\'\-]*$'),
      Validators.minLength(2),
      Validators.maxLength(32)]],
      'email': ['', [Validators.required,
      Validators.pattern(this.eRgex)]],
      'voucherCode': ['', [Validators.required,
      Validators.minLength(8),
      Validators.maxLength(8)]]

    });
  
    this.appService.makecursorWorkFine();
    this.appService.hideLoader();
    this.appService.hideLoaderWithText();
    this.appService.removeScrollBody();

  }

  formSubmitWithTC() {
    if (this.crewForm.get('firstName').errors) {
      this.showFnameErrorMsg = true;

    } else if (this.crewForm.get('lastName').errors) {
      this.showLnameErrorMsg = true;

    } else if (this.crewForm.get('email').errors) {
      this.showEmailErrorMsg = true;
    }
    else if (this.crewForm.get('voucherCode').errors) {
      this.showVoucherErrorMsg = true;
    }
  }

  voucherFormSubmit() {
    if (this.crewForm.valid) {
      this.travelersService.setCrewFormData(this.crewForm.value);
      this.connectToWifiCrewVoucher();
    }
    else {

      this.formSubmitWithTC();
    }
  }


  connectToWifiCrewVoucher() {
    const deviceToken = this.appService.getDeviceToken();
    const getDevicRequestEntity = this.landingService.getDeviceRequestEntity(deviceToken);
    this.httpService.getData(getDevicRequestEntity).subscribe(
      getDeviceResponse => {
        if (getDeviceResponse.errors) {
          this.errorService.addError(getDeviceResponse.errors);
          this.appService.hideLoader();
          return false;
        } else {
          if (getDeviceResponse !== null) {
            this.appService.setGetDeviceResponse(getDeviceResponse);
            //console.log(getDeviceResponse);
          }

          const loaderTextList = { loaderHeaderText: 'loaderText' };
          this.appService.showLoaderWithText(loaderTextList);
          const crewFormData = this.travelersService.getCrewFormData();
          // const getDeviceData = this.landingService.getGetDeviceResponse();
          // console.log("getDevice", getDeviceData);
          const deviceName = this.landingService.getDeviceName();
          let activateRequest: any;
          if (!getDeviceResponse['passenger']) {
            activateRequest = this.travelersService.activateCallRequestUrlForCrewVoucher(getDeviceResponse, crewFormData, deviceName);

            if (getDeviceResponse['status'].code !== 'FULL') {
              this.doActivateCall(activateRequest, 'voucherCode');
            }
          }
          else {
            this.errorService.addError(this.landingService.getDefaultError());
            this.appService.hideLoader();
            this.landingService.hideLandingBannerText();
            this.appService.hideLoaderWithText();
            return false;

          }
        }
      });

  }


  doActivateCall(request, type) {
    this.activateService.doCrewActivateCall(request).subscribe(
      activateResponse => {
        if (activateResponse.errors) {
          this.errorService.addError(activateResponse.errors);
          //  this.updateActivateErrorInfo(activateResponse, request, type);
          this.appService.scrollToActivateModel();
        }
      
        else if (activateResponse.status && activateResponse.status.code === 'FULL') {
          this.errorService.removeError();
          this.enableDisableViewBasedOnActivateResponse();

        }
      },
      error => {
        this.activateCallCompleted = true;
        this.activateCallSuccess = false;
        this.errorService.addError(this.landingService.getDefaultError());
        this.showErrorMsg;
        if (type === 'voucherCode') {
          this.appService.hideLoader();
          this.appService.hideLoaderWithText();
        }
      }
    )
  }

  //  actionBasedOnType(activateResponse, type) {
  //   if (type === 'voucherCode') {
  //     this.datalayerService.activateDataLayer('Connection successful  - Booking reference');
  //   } else {
  //     this.datalayerService.activateDataLayer('Connection successful  - Eurobonus');
  //   }
  // }

  enableDisableViewBasedOnActivateResponse() {
    this.activateCallSuccess = true;
    this.activateCallCompleted = true;
    LandingComponent.isDeviceActivated = true;
    LandingComponent.showLandingBanner = false;
    LandingComponent.showActivateScreen = false;
    LandingComponent.showSwitchScreen = false;
  }
  onActiveEmail() {
    this.showEmailErrorMsg = false;
    this.emailFocused = true;
    this.checkEmailValue();
    this.emailTopSet = true;
  }

  onBlurEmail() {
    if (this.crewForm.get('email').value !== '') {
      this.showEmailErrorMsg = true;
    } else {
      this.showEmailErrorMsg = false;
    }
    this.accessibilityService.updateAttributeValue('#email', 'aria-invalid', 'true');
    this.emailFocused = false;
    this.checkEmailValue();
  }

  checkEmailValue() {
    let emailEmpty: any;
    const emailErrors = this.crewForm.get('email').errors;
    if (emailErrors) {
      emailEmpty = emailErrors.required;
    }
    if (!emailEmpty || this.emailFocused) {
      this.emailTopSet = true;
    } else {
      this.emailTopSet = false;
    }
    if (!emailErrors) {
      this.accessibilityService.updateAttributeValue('#email', 'aria-invalid', 'false');
    }
  }

  get firstName() {
    return this.crewForm.get('firstName');
  }

  get lastName() {
    return this.crewForm.get('lastName');
  }

  get email() {
    return this.crewForm.get('email');
  }

  get voucherCode() {
    return this.crewForm.get('voucherCode');
  }



  onBlurLname() {
    if (this.crewForm.get('lastName').value !== '') {
      this.showLnameErrorMsg = true;
    } else {
      this.showLnameErrorMsg = false;
    }
    this.accessibilityService.updateAttributeValue('#lastName', 'aria-invalid', 'true');
    this.lNameFocused = false;
    this.checkLnameValue();
  }

  checkFnameValue() {
    let fnameEmpty: any;
    const fnameErrors = this.crewForm.get('firstName').errors;
    if (fnameErrors) {
      fnameEmpty = fnameErrors.required;
    }
    if (!fnameEmpty || this.fNameFocused) {
      this.fnameTopSet = true;
    } else {
      this.fnameTopSet = false;
    }
    if (!fnameErrors) {
      this.accessibilityService.updateAttributeValue('#firstName', 'aria-invalid', 'false');
    }
  }

  onBlurFname() {
    if (this.crewForm.get('firstName').value !== '') {
      this.showFnameErrorMsg = true;
    } else {
      this.showFnameErrorMsg = false;
    }
    this.accessibilityService.updateAttributeValue('#firstName', 'aria-invalid', 'true');
    this.fNameFocused = false;
    this.checkFnameValue();
  }


  onActiveFname() {
    this.showFnameErrorMsg = false;
    this.fNameFocused = true;
    this.checkFnameValue();
    this.fnameTopSet = true;
  }

  onActiveLname() {
    this.showLnameErrorMsg = false;
    this.lNameFocused = true;
    this.checkLnameValue();
    this.lnameTopSet = true;
  }

  onActiveCrewVoucher() {
    this.showVoucherErrorMsg = false;
    this.displayVoucherInfoIcon = false;
    this.voucherFocused = true;
    this.checkVoucherValue();
    this.pnrTopSet = true;
  }

  onActiveVoucherInfoIcon() {
    this.displayVoucherInfo = true;
  }

  onBlurVoucherInfoIcon() {
    this.displayVoucherInfo = false;
  }

  onActiveEmailInfoIcon() {
    this.displayEmailInfo = true;
  }

  onBlurEmailInfoIcon() {
    this.displayEmailInfo = false;
  }

  checkVoucherValue() {
    let voucherEmpty: any;
    const pnrErrors = this.crewForm.get('voucherCode').errors;
    if (pnrErrors) {
      voucherEmpty = pnrErrors.required;
    }
    if (!voucherEmpty || this.voucherFocused) {
      this.pnrTopSet = true;
    } else {
      this.pnrTopSet = false;
    }
    if (!pnrErrors) {
      this.accessibilityService.updateAttributeValue('#voucher', 'aria-invalid', 'false');
    }
  }


  checkLnameValue() {
    let LnameEmpty: any;
    const lnameErrors = this.crewForm.get('lastName').errors;
    if (lnameErrors) {
      LnameEmpty = lnameErrors.required;
    }
    if (!LnameEmpty || this.lNameFocused) {
      this.lnameTopSet = true;
    } else {
      this.lnameTopSet = false;
    }
    if (!lnameErrors) {
      this.accessibilityService.updateAttributeValue('#lastName', 'aria-invalid', 'false');
    }
  }


  onBlurVoucher() {
    if (this.crewForm.get('voucherCode').value !== '') {
      this.showVoucherErrorMsg = true;
    } else {
      this.showVoucherErrorMsg = false;
    }
    this.accessibilityService.updateAttributeValue('#voucher', 'aria-invalid', 'true');
    this.voucherFocused = false;
    this.checkVoucherValue();
  }

  // checkVoucherState(state) {
  //   if (state === 'focused' || this.voucher.value) {
  //     this.voucherTopSet = true;
  //   } else {
  //     this.voucherTopSet = false;
  //   }
  // }

  closeVoucherConnectOverlay() {
    //console.log('CLose');
    this.appService.addScrollBody();
    this.errorService.removeError();
    this.appService.hideLoader();
    //  this.appService.showLandingCustomer();
    this.appService.removeCustomerErrors();
    // LandingComponent.showCrewVoucherLogin = false;
    this.router.navigate(["/home"]);
    this.appService.scrollToTop();
    //this.accessibilityService.focus('#landing-connect');

  }

}
